// extracted by mini-css-extract-plugin
export var button = "ShareEntryForm-module--button--5ed03";
export var dialog = "ShareEntryForm-module--dialog--00b28";
export var shareForm = "ShareEntryForm-module--shareForm--dfb43";
export var sheet = "ShareEntryForm-module--sheet--4a6e0";
export var toggle = "ShareEntryForm-module--toggle--edb76";